import { createSelector } from 'reselect';
import type { WhatsAppMessagesReduxState } from './types';

/**
 * whatsAppMessagesSelector
 * Selector for the WhatsApp Messages State state.
 */
export const whatsAppMessagesSelector = (state: WhatsAppMessagesReduxState) =>
  state.insights.whatsAppMessages;

/**
 * selectWhatsAppMessages
 * Selects the WhatsApp Messages from the WhatsApp Message state.
 */
export const selectWhatsAppMessages = createSelector(
  [whatsAppMessagesSelector],
  (whatsAppMessages) =>
    whatsAppMessages.whatsAppReceivedMessages.map((whatsAppMessage, i) => {
      return {
        ...whatsAppMessage,
        /** Since the WhatsApp messages returned from the API have no unique identifier, we need to add one to make sure that the react table can properly render the rows. */
        id: i,
      };
    }),
);
